let pintrk;

function loadPinterestPixelScript() {
  (function(e) {
    if (!window.pintrk) {
      window.pintrk = function() {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments));
      };
      var n = window.pintrk;
      n.queue = [];
      n.version = '3.0';
      var t = document.createElement('script');
      t.async = true;
      t.src = e;
      var r = document.getElementsByTagName('script')[0];
      r.parentNode.insertBefore(t, r);
    }
  })('https://s.pinimg.com/ct/core.js');
}

async function initializePinterestPixel(ID_DE_PINTEREST_TAG) {
  try {
    if (ID_DE_PINTEREST_TAG !== undefined && ID_DE_PINTEREST_TAG !== null && ID_DE_PINTEREST_TAG !== '') {
      loadPinterestPixelScript();
      pintrk = window.pintrk;
      pintrk('load', ID_DE_PINTEREST_TAG);
      pintrk('page');  // Track PageView event
      pintrk('track', 'PageVisit');  // Example of tracking additional event
    } else {
      console.log('Pinterest Tag ID is missing!');
    }
  } catch (error) {
    console.log('Error setting up Pinterest Tag:', error);
  }
}

export { initializePinterestPixel, pintrk };
